export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <div className="mt-12 text-center text-xs text-white/40">
      © {year} Premiei
    </div>
  );
}
